import React from 'react';
import {injectIntl} from 'react-intl';
import Icon from '@Components/Icon';

const ExperienceFilter = ({intl, experience, setExperience}) => {
  const onChange = (event) => {
    event.preventDefault();
    setExperience((prev) => {
      return {
        ...prev,
        experience: event.target.value,
      };
    });
  };

  return (
    <>
      <label className="form-group__label" htmlFor="experience">{intl.formatMessage({id: 'ExperienceFilter.Label'})}</label>
      <div className="form-group__input">
        <select
          className={experience ? '' : 'untouched'}
          id="experience"
          name="experience"
          onChange={onChange}
          value={experience ? experience : '_none'}
        >
          <option key="_none" value="_none" hidden disabled>{intl.formatMessage({id: 'ExperienceFilter.FilterPlaceholder'})}</option>,
          <option key={0} value={'EntryLevel'}>{intl.formatMessage({id: 'ExperienceFilter.Option.EntryLevel'})}</option>
          <option key={1} value={'Experienced'}>{intl.formatMessage({id: 'ExperienceFilter.Option.Experienced'})}</option>
          <option key={2} value={'SeniorManagement'}>{intl.formatMessage({id: 'ExperienceFilter.Option.SeniorManagement'})}</option>
        </select>
        <span className="select-arrow icon">
          <Icon type="chevron-down"/>
        </span>
      </div>
    </>
  );
};

export default injectIntl(ExperienceFilter);
